module.exports = "/_next/static/images/33946a7d76685255046b80cd634adace-nubanker-ds@2x.jpg";